<template>
    <div class="modal" tabindex="-1" role="dialog" v-if="visibility" style="display:block">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Информация</h5>
                </div>
                <div class="modal-body">
                    <p class="text-center">{{message}}</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="clearChoose">Закрыть</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "Alert",
    props: ["visibility","message"],
    methods:{
      clearChoose() {
        this.$emit("closeDialog", false)
      },
    }
  }
</script>

<style scoped>
    .modal-header {
       background: #30ade7;
       color: white;
       text-transform: uppercase;
    }
    .modal-header h5{
        font-weight: bold;
    }
</style>
